import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

export const RECIPIENT_TYPES = ['parent', 'staff', 'student']


export const searchRecipients = createApiAction(
  'notification/recipients/search',
  client.search('/api/notification/list'),
)

const typeOf = action => action.meta?.arg?.type

const initialState = {
  parent: null,
  staff: null,
  student: null,
  loading: { parent: false, staff: false, student: false },
  failed: { parent: false, staff: false, student: false },
  error: null,
}

const slice = createSlice({
  name: 'notificationRecipients',
  initialState,
  reducers: {
    clearRecipients: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(searchRecipients.pending, (state, action) => {
        const type = typeOf(action)

        if (type) {
          state.loading[type] = true
          state.failed[type] = false
        }

        state.error = null
      })
      .addCase(searchRecipients.fulfilled, (state, action) => {
        const type = typeOf(action)
        if (!type) return
        state[type] = action.payload?.rows ?? []
        state.loading[type] = false
      })
      .addCase(searchRecipients.rejected, (state, action) => {
        const type = typeOf(action)

        if (type) {
          state.loading[type] = false
          state[type] = []
          state.failed[type] = true
        }

        state.error = action.error?.message ?? null
      })
  },
})

export const { clearRecipients } = slice.actions
export default slice.reducer
